import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Product, ProductCreate, ProductFilter } from '../data/product';

export function createProductService(client: AxiosInstance) {
  return createCrudService<Product, ProductCreate, ProductFilter>(client, "/master-data/Product", "productId");
}

export type ProductService = CrudService<Product, ProductCreate, ProductFilter>;
